import AuthActionTypes from "./auth.types";

export const validateCode = (payload) => ({
    type: AuthActionTypes.VALIDATE_CODE,
    payload,
});

export const userSignin = (payload) => ({
    type: AuthActionTypes.SIGNIN_START,
    payload,
});

export const userSigninSuccess = (payload) => ({
    type: AuthActionTypes.SIGNIN_SUCCESS,
    payload,
});

export const userSigninFailure = (payload) => ({
    type: AuthActionTypes.SIGNIN_FAILURE,
    payload,
});

export const userSignOut = (payload) => ({
    type: AuthActionTypes.SIGN_OUT,
    payload,
});

export const updateSubscription = (payload) => ({
    type: AuthActionTypes.UPDATE_SUBSCRIPTION,
    payload,
});

export const updateEmployee = (payload) => ({
    type: AuthActionTypes.UPDATE_EMPLOYEE,
    payload,
});

export const reset = (payload) => ({
    type: AuthActionTypes.RESET,
    payload,
});
